// src/services/entraAuth.ts
//
// Client wrapper around the Entra auth router mounted at /api/auth.
// Flow:
//   1. checkDomain(email) classifies into internal|external|local|unknown.
//   2. loginInternal() / loginExternal(email) do full-page navigation
//      so the browser handles the 302 → Microsoft → callback loop
//      and the HttpOnly state cookie set by the backend survives.
//   3. validateCode(code) is called from AuthCallback to exchange the
//      one-time app code for a JWT and user object.

import api from './api';
import { CheckDomainResponse, ValidateResponse } from '../types/entraAuth';

export const entraAuthService = {
  async checkDomain(email: string): Promise<CheckDomainResponse> {
    const r = await api.post<CheckDomainResponse>('/auth/check-domain', { email });
    return r.data;
  },

  loginInternal(): void {
    window.location.href = `${api.defaults.baseURL}/auth/internal/login`;
  },

  loginExternal(email: string): void {
    const qs = new URLSearchParams({ email }).toString();
    window.location.href = `${api.defaults.baseURL}/auth/external/login?${qs}`;
  },

  async validateCode(code: string): Promise<ValidateResponse> {
    const r = await api.post<ValidateResponse>('/auth/validate', { code });
    return r.data;
  },
};
